$shm_hitalama_skills_repository $mol_page
	catalog $shm_hitalama_skills_catalog
	title \Репозиторий скиллов
	minimal_width 480
	opened? true
	tools /
		<= Close $mol_button_minor
			hint \Закрыть репозиторий скиллов
			click? <=> close? null
			sub / <= Close_icon $mol_icon_close
	body /
		<= Repository $mol_labeler
			title \GitHub-репозиторий
			Content <= Repository_input $mol_string
				enabled <= editable false
				value? <=> repository? \hitalama/hitalama-skills
		<= Notice $mol_text
			text \Сохраняется весь каталог: SKILL.md и все дополнительные файлы каждого скилла, группы и порядок. Отсутствующий репозиторий создаётся закрытым только при нажатии «Сделать коммит». Используется GitHub-токен из настроек профиля. Приватность GitHub не меняет публичность скиллов в гипербазе.
		<= Status $mol_status
			status <= status \
			attr *
				^
				data-sync-state <= sync_state \
		<= Actions $mol_view
			sub /
				<= Refresh $mol_button_minor
					title \Обновить проверку
					click? <=> refresh? null
				<= Commit $mol_button_major
					title \Сделать коммит
					enabled <= commit_enabled false
					click? <=> commit? null
